<template>
  <ul ref="tab" class="tabs">
    <li :class="classObject('main')" @click="goPath('/user/transaction')">
      <a>{{ $t("Bao.main_wallet_detail") }}</a>
    </li>
    <li :class="classObject('bonus')" @click="goPath('/user/bonus')">
      <a>{{ $t('Bao.bonus_wallet_detail') }}</a>
    </li>
    <li :class="classObject('commission')" @click="goPath('/user/commission')">
      <a>{{ $t("Bao.commission_gold") }}</a>
    </li>
    <li :class="classObject('deposit-record')" @click="goPath('/user/deposit-record')">
      <a>{{ $t("Bao.deposit_detail") }}</a>
    </li>
    <li :class="classObject('withdrawal-record')" @click="goPath('/user/withdrawal-record')">
      <a>{{ $t("Bao.withdrawal_detail_2") }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AccountDetail',
  props: {
    'tabName': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeTab: this.tabName
    }
  },
  computed: {
    currentTab() {
      return this.getActiveTabFromRoute(this.$router.currentRoute.path)
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.activeTab = this.currentTab
        this.scrollToActive()
      }
    }
  },
  methods: {
    classObject: function(tabName) {
      let classDesc = 'btn btn_quick align-items-center justify-content-center'
      if (this.activeTab === tabName) {
        classDesc += ' active'
      }
      return classDesc
    },
    goPath(path) {
      if (this.$router.currentRoute.path.indexOf('/web') >= 0) {
        this.$router.push('/web' + path)
      } else {
        this.$router.push(path)
      }
    },
    scrollToActive() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs['tab']
          const activeItem = container.querySelector('.active')
          if (activeItem) {
            const containerRect = container.getBoundingClientRect()
            const activeItemRect = activeItem.getBoundingClientRect()

            let scrollPosition
            if (activeItem === container.lastElementChild) {
              scrollPosition = container.scrollWidth - container.clientWidth
            } else {
              scrollPosition = activeItemRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (activeItemRect.width / 2)
            }

            container.scrollLeft = scrollPosition
          }
        }, 300)
      })
    },
    getActiveTabFromRoute(routePath) {
      if (routePath.includes('/user/transaction')) return 'main'
      if (routePath.includes('/user/bonus')) return 'bonus'
      if (routePath.includes('/user/commission')) return 'commission'
      if (routePath.includes('/user/deposit-record')) return 'deposit-record'
      if (routePath.includes('/user/withdrawal-record')) return 'withdrawal-record'
      return ''
    }
  }
}
</script>
